export const getRunner = (biRunner, runnerName) =>
  biRunner &&
  biRunner.runners.find(
    (runner) => runner.horseName.toLowerCase() === runnerName.toLowerCase()
  );

const getRaceAtiveRunnerBI = (runners, activeRunner) =>
  runners.find((biRunner) => getRunner(biRunner, activeRunner));

export default getRaceAtiveRunnerBI;
